import type { OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { textVariants } from '@freelancer/ui/text';
import { FontColor, FontWeight, TextSize } from '@freelancer/ui/text';

@Component({
  standalone: false,
  selector: 'fl-showcase-card-price',
  template: `
    @if (label) {
      <p
        [class]="labelClasses"
        [class.mr-xxsmall]="true"
      >
        {{ label }}
      </p>
    }
    <div class="CostCircle">
      <p
        i18n="Category Banner Price"
        [class]="costClasses"
      >
        {{ cost | flCurrency: currency : { withPrecision: false } }}
      </p>
    </div>
  `,
  styleUrls: ['./showcase-card-price.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShowcaseCardPriceComponent implements OnChanges, OnInit {
  currentTextSize = TextSize.BODY_16;

  @Input() cost: number;
  @Input() currency = 'USD';
  @Input() label?: string;

  labelClasses: string;
  costClasses: string;

  ngOnInit(): void {
    this.computeClasses();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('cost' in changes) {
      const numOfDigits = this.cost.toString().length;
      if (numOfDigits > 5) {
        this.currentTextSize = TextSize.BODY_12;
      } else if (numOfDigits > 3) {
        this.currentTextSize = TextSize.BODY_16;
      } else {
        this.currentTextSize = TextSize.BODY_16;
      }
    }

    if ('cost' in changes || 'label' in changes) {
      this.computeClasses();
    }
  }

  private computeClasses(): void {
    this.labelClasses = textVariants({
      color: FontColor.LIGHT,
      weight: FontWeight.BOLD,
      size: this.currentTextSize,
    });

    this.costClasses = textVariants({
      color: FontColor.LIGHT,
      weight: FontWeight.BOLD,
      size: this.currentTextSize,
    });
  }
}
